/* eslint-disable */
import React, {Component} from 'react';
import Scrollbars from 'react-custom-scrollbars';
import _ from 'lodash';

export default class RateList extends Component {

  constructor(props, ...rest) {
    super(props, ...rest);
    this.state = { top: 0 };
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleClickRandomPosition = this.handleClickRandomPosition.bind(this);
    this.renderThumb = this.renderThumb.bind(this);
  }

  handleUpdate(values) {
    const { top } = values;
    if (top !== this.state.top) {
      this.setState({ top });
    }
  }

  handleClickRandomPosition(elem, mid, select) {
    const {scrollbars} = this.refs;
    const result = _.find(elem, (user => user.mid === mid));
    select();
    result && scrollbars.scrollTop(this._li.offsetTop - 133);
  }

  renderName(elem, selected, mid) {
    const ref = li => elem.mid === mid ? this._li = li : "";
    return (
      <li key={elem.mid} id={elem.mid} ref={ref}
        className={elem.mid === mid ? 'selected_render_name' : ''}>{elem.num}. {elem.xp_f_get_mid_fio}
      <span>{elem.avg}</span></li>
    )
  };

  renderThumb({style, ...props}) {
    const thumbStyle = {
      backgroundColor: '#5e2423'
    };
    return (
      <div
        style={{...style, ...thumbStyle}}
        {...props}>
      </div>
    );
  }

  renderView({style, ...props}) {
    const thumbStyle = {
      marginBottom: '-15px',
    };
    return (
      <div
        style={{...style, ...thumbStyle}}
        {...props}>
      </div>
    );
  }

  render() {
    const {elem, i, mid, selected, select} = this.props;
    return (
      <div className='full-drum' key={i}>
        <p>{elem.name}</p>
        <Scrollbars
          ref="scrollbars"
          style={{height: 300, width: 285}}
          className='drum justify-content'
          renderThumbVertical={values => this.renderThumb(values, elem.list.length)}
          renderView={this.renderView}
          renderThumbHorizontal={() => <div/>}
          onUpdate={this.handleUpdate}
        >
          <ul>
            <li>Рейтинг <span>ср. балл</span></li>
            {elem.list.map(table => this.renderName(table , selected, mid))}
          </ul>
        </Scrollbars>
        <a role='button' className='drum-search link' onClick={() => this.handleClickRandomPosition(elem.list, mid, select)}>найти
          себя</a>
      </div>
    );
  }
}